import type { Kit, Producto } from '@/types';

/** Datos de demostración cuando la API aún no está disponible */
export const MOCK_PRODUCTOS: Producto[] = [
  {
    id_pto: 1,
    modelo_pto: 'DS-2CD2047G2-LU',
    nombre_pto: 'Cámara IP Bullet 4MP ColorVu',
    descripcion_pto: 'Cámara IP bullet 4 megapixel con visión a color 24/7',
    descripcion_web: 'Exterior, IP67. Micrófono integrado. ColorVu para baja luz.',
    precio_venta: 4890,
    precio_oferta: 4290,
    imagen: null,
    categoria: 'cctv',
    marca: 'Hikvision',
    sku: 'HIK-4MP-CV',
    existencias: 24,
    visible_ecommerce: true,
  },
  {
    id_pto: 2,
    modelo_pto: 'DS-K1T671M',
    nombre_pto: 'Terminal biométrico facial',
    descripcion_pto: 'Control de acceso con reconocimiento facial',
    descripcion_web: 'Standalone. Pantalla táctil. Hasta 6,000 rostros en memoria.',
    precio_venta: 12500,
    imagen: null,
    categoria: 'acceso',
    marca: 'Hikvision',
    sku: 'HIK-FACE-01',
    existencias: 8,
    visible_ecommerce: true,
  },
  {
    id_pto: 3,
    modelo_pto: 'DSC-1832',
    nombre_pto: 'Panel de alarma 8 zonas',
    descripcion_pto: 'Panel híbrido expandible para sistemas de intrusión',
    descripcion_web: 'Híbrido cableado/inalámbrico PowerG. Expande zonas según proyecto.',
    precio_venta: 6200,
    imagen: null,
    categoria: 'intrusion',
    marca: 'DSC',
    sku: 'DSC-1832',
    existencias: 15,
    visible_ecommerce: true,
  },
  {
    id_pto: 4,
    modelo_pto: 'NVR-8CH-4K',
    nombre_pto: 'Grabadora NVR 8 canales 4K',
    descripcion_pto: 'NVR de 8 canales con soporte PoE',
    precio_venta: 8900,
    precio_oferta: 7990,
    imagen: null,
    categoria: 'cctv',
    marca: 'Alarcom',
    sku: 'NVR-8-4K',
    existencias: 12,
    visible_ecommerce: true,
  },
  {
    id_pto: 5,
    modelo_pto: 'PIR-WIRELESS',
    nombre_pto: 'Sensor de movimiento inalámbrico',
    descripcion_pto: 'Detector PIR pet-immune',
    precio_venta: 890,
    imagen: null,
    categoria: 'intrusion',
    existencias: 45,
    visible_ecommerce: true,
  },
  {
    id_pto: 6,
    modelo_pto: 'SW-24P-PoE',
    nombre_pto: 'Switch PoE 24 puertos administrable',
    descripcion_pto: 'Switch gigabit con 24 puertos PoE+',
    precio_venta: 14200,
    imagen: null,
    categoria: 'redes',
    existencias: 6,
    visible_ecommerce: true,
  },
];

export const MOCK_KITS: Kit[] = [
  {
    id_kit: 1,
    nombre: 'Kit CCTV Residencial 4 Cámaras',
    slug: 'kit-cctv-residencial-4',
    descripcion: 'Solución completa para casa o negocio pequeño',
    descripcion_web: '4 cámaras 4MP, NVR 8 canales, disco 2TB, accesorios de montaje.',
    precio: 24900,
    precio_oferta: 21900,
    imagen: null,
    tipo_venta_producto: 'CCTV',
    activo: true,
    existencias_disponibles: 5,
    productos: [
      { id_pto: 1, modelo_pto: 'DS-2CD2047G2-LU', nombre_pto: 'Cámara IP 4MP', cantidad: 4 },
      { id_pto: 4, modelo_pto: 'NVR-8CH-4K', nombre_pto: 'NVR 8 canales', cantidad: 1 },
    ],
  },
  {
    id_kit: 2,
    nombre: 'Kit Intrusión Básico',
    slug: 'kit-intrusion-basico',
    descripcion: 'Protección perimetral esencial',
    precio: 9800,
    imagen: null,
    tipo_venta_producto: 'Intrusion',
    activo: true,
    existencias_disponibles: 10,
    productos: [
      { id_pto: 3, modelo_pto: 'DSC-1832', nombre_pto: 'Panel 8 zonas', cantidad: 1 },
      { id_pto: 5, modelo_pto: 'PIR-WIRELESS', nombre_pto: 'Sensor PIR', cantidad: 4 },
    ],
  },
];
